import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import {
  IoArrowBack,
  IoInformationCircleOutline,
  IoBriefcaseOutline,
  IoPersonOutline,
  IoHammerOutline,
  IoQrCodeOutline
} from 'react-icons/io5';
import { useAuth } from '../context/AuthContext';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import SafeAreaInsets from '../components/Shared/SafeAreaInsets';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import './NuevoProveedorScreen.css'; // --- Premium CSS ---

// Opciones de servicios
const SERVICIOS_HOGAR = [
  "Jardinero", "Plomero", "Electricista", "Servicios Domésticos",
  "Carpintero", "Albañil", "Pintor", "Herrero", "Niñera",
  "Paseador de Perros", "Otro, especifique"
];

// Fechas helper
const getTodayString = () => new Date().toISOString().split('T')[0];
const getMaxDateString = () => {
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 60); // Max 60 días
  return maxDate.toISOString().split('T')[0];
}

function NuevoProveedorScreen() {
  const navigate = useNavigate();
  const { currentUser, isMoroso, userData } = useAuth();

  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');

  // Estados del formulario
  const [tipoProveedor, setTipoProveedor] = useState('Empresa'); // Default Empresa
  const [nombreComercial, setNombreComercial] = useState('');
  const [nombres, setNombres] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [tipoServicio, setTipoServicio] = useState('');
  const [otroServicio, setOtroServicio] = useState('');
  const [contacto, setContacto] = useState('');
  const [fechaInicio, setFechaInicio] = useState(getTodayString());
  const [fechaFin, setFechaFin] = useState(getTodayString());


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!currentUser) {
      setError("Error: No se ha podido identificar al usuario.");
      return;
    }
    if (isMoroso) {
      setError("No puedes registrar proveedores mientras tengas adeudos pendientes.");
      return;
    }

    const nombreFinalServicio = tipoServicio === 'Otro, especifique' ? otroServicio : tipoServicio;
    const nombreFinalProveedor = tipoProveedor === 'Empresa' ? nombreComercial : `${nombres} ${apellidos}`;

    // Validaciones basicas
    if (!nombreFinalServicio || !contacto || !fechaInicio || !fechaFin) {
      setError('Por favor completa todos los campos.');
      return;
    }
    if (tipoProveedor === 'Empresa' && !nombreComercial) { setError('Falta nombre comercial.'); return; }
    if (tipoProveedor === 'Particular' && (!nombres)) { setError('Falta nombre.'); return; }
    if (contacto.length !== 10) { setError('El contacto debe ser de 10 dígitos.'); return; }
    if (new Date(fechaFin) < new Date(fechaInicio)) { setError('La fecha de fin es inválida.'); return; }

    setEnviando(true);

    try {
      const token = Math.floor(100000 + Math.random() * 900000).toString(); // 6 dígitos numéricos
      // Aseguramos inicio a las 00:00 y fin a las 23:59 del dia seleccionado
      const inicioTimestamp = Timestamp.fromDate(new Date(fechaInicio + 'T00:00:00'));
      const finTimestamp = Timestamp.fromDate(new Date(fechaFin + 'T23:59:59'));

      const rawCasa = userData?.numeroCasa || userData?.casaNumero || userData?.residencia || userData?.depto || userData?.unidadResidente || userData?.unidad || '';
      const cleanCasa = (rawCasa && rawCasa !== 'S/N' && rawCasa !== 'N/A' && rawCasa !== 'Sin Unidad') ? String(rawCasa).replace(/^(casa|depto)\s*/i, '').trim() : '';

      const accesosRef = collection(db, "accesos");
      await addDoc(accesosRef, {
        residenteId: currentUser.uid,
        residenteNombre: userData?.nombre || '',
        condominioId: userData?.condominioId || '',
        cuentaPadreId: userData?.cuentaPadreId || null,
        token: token,
        tipo: 'Proveedor',
        nombreVisita: nombreFinalProveedor,
        nombre: nombreFinalProveedor,
        numeroCasa: cleanCasa,
        tipoProveedor: tipoProveedor,
        nombreComercial: tipoProveedor === 'Empresa' ? nombreComercial : null,
        nombreCompleto: tipoProveedor === 'Particular' ? `${nombres} ${apellidos}` : null,
        tipoServicio: nombreFinalServicio,
        contacto: contacto,
        fechaCreacion: Timestamp.now(),
        fechaInicio: inicioTimestamp,
        expira: finTimestamp,
        usosDiariosMaximos: 2,
        usosActuales: 0,
        // --- HORARIO LABORAL ESTRICTO ---
        horarioInicio: '09:00',
        horarioFin: '18:00',
        estatus: 'Activo'
      });

      alert(`¡Acceso para ${nombreFinalProveedor} creado!\nToken: ${token}`);
      navigate('/accesos/proveedores');

    } catch (error) {
      console.error("Error al crear acceso: ", error);
      setError('Error al crear el acceso en base de datos.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/accesos" />

      <main className="ks-main">
        <SafeAreaInsets top={false} bottom={true} />

        {/* Sticky Header unificado */}
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>

        <div className="ks-scroll-area">
          <div className="new-prov-container">
            {/* Sticky Compact Header */}
            <div className="new-prov-fixed-wrapper">
              <div className="new-prov-banner-compact">
                <button type="button" onClick={() => navigate('/accesos/proveedores')} className="new-back-btn glass" aria-label="Volver">
                  <IoArrowBack size={24} />
                </button>
                <div className="new-prov-banner-content">
                  <h2>Nuevo Proveedor</h2>
                  <p>Registra servicios y mantenimiento</p>
                </div>
                <div className="new-prov-banner-icon">
                  <IoHammerOutline />
                </div>
              </div>
            </div>

            <div className="new-prov-card">
              {/* --- Info Widget --- */}
              <div className="new-prov-info-box">
                <div className="info-icon-blue"><IoInformationCircleOutline size={24} /></div>
                <div className="info-content">
                  <h4>Acceso Limitado</h4>
                  <p>El código QR será válido solo en las fechas seleccionadas y en horario laboral <b>(9:00 AM - 6:00 PM)</b>.</p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="new-prov-form">
                {error && <div className="error-message">{error}</div>}

                {/* Selector Tipo */}
                <div className="form-group-grid">
                  <div onClick={() => setTipoProveedor('Empresa')}
                    className={`form-field-card ${tipoProveedor === 'Empresa' ? 'selected' : ''}`}
                    style={{
                      border: tipoProveedor === 'Empresa' ? '2px solid #2563eb' : '1px solid #e2e8f0',
                      padding: 12, borderRadius: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                      backgroundColor: tipoProveedor === 'Empresa' ? '#eff6ff' : 'white'
                    }}
                  >
                    <IoBriefcaseOutline size={20} color={tipoProveedor === 'Empresa' ? '#2563eb' : '#64748b'} />
                    <span style={{ fontWeight: 600, color: tipoProveedor === 'Empresa' ? '#1e3a8a' : '#475569' }}>Empresa</span>
                  </div>
                  <div onClick={() => setTipoProveedor('Particular')}
                    className={`form-field-card ${tipoProveedor === 'Particular' ? 'selected' : ''}`}
                    style={{
                      border: tipoProveedor === 'Particular' ? '2px solid #2563eb' : '1px solid #e2e8f0',
                      padding: 12, borderRadius: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                      backgroundColor: tipoProveedor === 'Particular' ? '#eff6ff' : 'white'
                    }}
                  >
                    <IoPersonOutline size={20} color={tipoProveedor === 'Particular' ? '#2563eb' : '#64748b'} />
                    <span style={{ fontWeight: 600, color: tipoProveedor === 'Particular' ? '#1e3a8a' : '#475569' }}>Particular</span>
                  </div>
                </div>

                {/* Campos de Nombre */}
                {tipoProveedor === 'Empresa' && (
                  <div className="form-field">
                    <label>Nombre Comercial</label>
                    <input type="text" value={nombreComercial} onChange={(e) => setNombreComercial(e.target.value)} className="form-input" placeholder="Ej. Soluciones del Hogar S.A." maxLength={30} />
                  </div>
                )}
                {tipoProveedor === 'Particular' && (
                  <div className="form-group-grid">
                    <div className="form-field">
                      <label>Nombre(s)</label>
                      <input type="text" value={nombres} onChange={(e) => setNombres(e.target.value)} className="form-input" />
                    </div>
                    <div className="form-field">
                      <label>Apellidos</label>
                      <input type="text" value={apellidos} onChange={(e) => setApellidos(e.target.value)} className="form-input" />
                    </div>
                  </div>
                )}

                <div className="form-group-grid">
                  <div className="form-field">
                    <label>Tipo de Servicio</label>
                    <div style={{ position: 'relative' }}>
                      <select value={tipoServicio} onChange={(e) => setTipoServicio(e.target.value)} className="form-select">
                        <option value="">Selecciona...</option>
                        {SERVICIOS_HOGAR.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                      <IoHammerOutline style={{ position: 'absolute', right: 12, top: 12, color: '#94a3b8', pointerEvents: 'none' }} />
                    </div>
                  </div>
                  <div className="form-field">
                    <label>Contacto (Celular)</label>
                    <input type="tel" value={contacto} onChange={(e) => setContacto(e.target.value.replace(/\D/g, ''))} className="form-input" maxLength={10} placeholder="10 dígitos" />
                  </div>
                </div>

                {tipoServicio === 'Otro, especifique' && (
                  <div className="form-field">
                    <label>Especifica el servicio</label>
                    <input type="text" value={otroServicio} onChange={(e) => setOtroServicio(e.target.value)} className="form-input" maxLength={20} />
                  </div>
                )}

                <div style={{ borderBottom: '1px solid #e2e8f0', margin: '10px 0' }}></div>

                <div className="form-group-grid">
                  <div className="form-field">
                    <label>Fecha Inicio</label>
                    <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} className="form-input" min={getTodayString()} max={getMaxDateString()} />
                  </div>
                  <div className="form-field">
                    <label>Fecha Fin</label>
                    <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} className="form-input" min={fechaInicio} max={getMaxDateString()} />
                  </div>
                </div>

                <button type="submit" className="btn-create" disabled={enviando}>
                  {enviando ? 'Creando...' : 'Crear Acceso QR'}
                  {!enviando && <IoQrCodeOutline size={20} />}
                </button>
              </form>
            </div>
          </div>
        </div>

        <KondoBottomNav activeRoute="/accesos" />
      </main>
    </div>
  );
}

export default NuevoProveedorScreen;